<template>
  <div class="ProductLabels">
    <span v-for="(label, index) in labels" class="ProductLabel" :key="index">
      <img :src="label.pictogram" :alt="label.name" />
      <span v-if="index === labels.length - 1">{{ label.name }}</span>
    </span>
  </div>
</template>

<script>

export default {
  name: "ProductLabels",
  props: {
    labels: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.ProductLabels {
  display: inline-block;
}

.ProductLabel {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.5rem;
  white-space: nowrap;

  img {
    margin-right: 0.225em;
    vertical-align: middle;
    width: 1rem;
  }

  span {
    margin-left: 0.225em;
  }
}

@media (min-width: 900px) {
  .ProductLabel {
    font-size: 0.625rem;

    img {
      width: 1.5rem;
    }
  }
}
</style>
